import request from '@/axios'

/**
 * @Description: 获取解决方案导航
 */
export function selectProductCenters(){
  return request({
    method:'post',
    url:'/api/ProductCenter/selectProductCenters',
    params: {}
  })
}

/**
 * @Description: 查询【根据id获取全部内容】
 */
export function selectProductCenterById(data){
  return request({
    method:'post',
    url:'/api/ProductCenter/selectProductCenterById',
    params: data
  })
}

